import m from "../../geodata/es2015/solomonIslandsHigh";
window.am4geodata_solomonIslandsHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/solomonIslandsHigh.js
// module id = null
// module chunks = 